import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React from 'react';
import styled from 'styled-components';
import { Text } from "../Text";
import { separateFileNameExtension } from "./separateFileNameExtension";
import { truncateStyles } from "../Text/Text";
/* NOTE: Due to the nature of ellipsis, at a certain width, a small offset c
an be seen between the truncated name and extension of the file. */

export function TextFileName(_ref) {
  var fileName = _ref.fileName,
      _ref$padExtension = _ref.padExtension,
      padExtension = _ref$padExtension === void 0 ? 0 : _ref$padExtension,
      style = _ref.style,
      other = _objectWithoutProperties(_ref, ["fileName", "padExtension", "style"]);

  var _separateFileNameExte = separateFileNameExtension({
    fileName: fileName,
    padExtension: padExtension
  }),
      name = _separateFileNameExte.name,
      extension = _separateFileNameExte.extension;

  return /*#__PURE__*/React.createElement(Text, _extends({}, other, {
    style: _objectSpread({
      display: 'flex'
    }, style)
  }), /*#__PURE__*/React.createElement(TruncatedSpan, null, name), /*#__PURE__*/React.createElement("span", null, extension));
}
var TruncatedSpan = styled.span.withConfig({
  displayName: "TextFileName__TruncatedSpan",
  componentId: "vapor__sc-14if0g6-0"
})(["", ""], truncateStyles);